<template>
  <div class="container" :class="gaugeColor">
      <div class="bar" v-for="index in 10" :key="'bar_' + index" :class="{'active' : value>=index}"></div>
  </div>
</template>

<script>


export default {
  name: 'BarGauge',
  data(){
    return {
      size: 300,
      lowValue: 25,
      highValue: 45,
      songPlaylistability: 35
    };
  },
  computed:{
    gaugeColor(){
      if (this.value <= 4){
        return 'danger';
      }
      if (this.value > 4 && this.value <= 7){
        return 'warning';
      }
      if (this.value > 7){
        return 'success';
      }
    },
    rangeDifferential(){
      return Number(this.highValue - this.lowValue) / 3;
    },
    lowRange(){
      return { Min: this.lowValue, Max: Number(this.lowValue + this.rangeDifferential) };
    },
    midRange(){
      return { Min: Number(this.lowValue + this.rangeDifferential), Max: Number(this.highValue - this.rangeDifferential) };
    },
    highRange(){
      return { Min: Number(this.highValue - this.rangeDifferential), Max: this.highValue };
    },
    ratingLabel(){
      if (this.songPlaylistability <= this.lowRange.Max){
        return 'poor';
      }
      if (this.songPlaylistability > this.midRange.Min && this.songPlaylistability <= this.midRange.Max){
        return 'good';
      }
      if (this.songPlaylistability > this.highRange.Min){
        return 'great';
      }
    },

  },
  methods:{
    increasePlaylistability(toValue){
      const vm = this;
      if (vm.songPlaylistability < toValue){
        vm.songPlaylistability++;
        setTimeout(() => { vm.increasePlaylistability(toValue); }, 20);
      }
    }
  },
  props: {
    value: Number
  },
  components: {

  },

  mounted() {
    // this.increasePlaylistability(45);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/variables.scss";

.container{
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-end;
    &.danger{
        .bar.active{
            background: $color-danger;
        }
    }
    &.warning{
        .bar.active{
            background: $color-warning;
        }
    }
    &.success{
        .bar.active{
            background: $color-success;
        }
    }
    .bar{
        width: 8%;
        margin: 0 1%;
        background: rgba($color-black, .25);

        &:nth-child(1){
            height: 10%;
        }
        &:nth-child(2){
            height: 20%;
        }
        &:nth-child(3){
            height: 30%;
        }
        &:nth-child(4){
            height: 40%;
        }
        &:nth-child(5){
            height: 50%;
        }
        &:nth-child(6){
            height: 60%;
        }
        &:nth-child(7){
            height: 70%;
        }
        &:nth-child(8){
            height: 80%;
        }
        &:nth-child(9){
            height: 90%;
        }
        &:nth-child(10){
            height: 100%;
        }
    }
}
</style>
